export default __webpack_public_path__ + "static/media/couronne.5e8c5bf5.png";